"use client";

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { LogOut } from "lucide-react";
import { logout } from "@store/features/authSlice";
import { useRouter } from "next/navigation";
import { ROUTES } from "@constants/routes";
import { useSelector } from "react-redux";
import { selectBrandName } from "@/lib/store/features/styleSchemaSlice";
import clsx from "clsx";

export default function LogoutButton() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const router = useRouter();
  const brand = useSelector(selectBrandName);

  const handleLogout = () => {
    dispatch(logout());
    router.push(ROUTES.root);
  };

  return (
    <button
      onClick={handleLogout}
      className={clsx("flex items-center gap-2 p-2 text-xl transition-colors", {
        "text-white": brand !== "styleboxx" && brand !== "hairexpress" && brand !== "cosmo",
        })}
      aria-label={t("auth.logout")}
      title={t("auth.logout")}
    >
      <LogOut size={18} />
    </button>
  );
}
